import { render, staticRenderFns } from "./ScreenMessageBoard.vue?vue&type=template&id=78d0d0cf&scoped=true"
import script from "./ScreenMessageBoard.vue?vue&type=script&lang=js"
export * from "./ScreenMessageBoard.vue?vue&type=script&lang=js"
import style0 from "./ScreenMessageBoard.vue?vue&type=style&index=0&id=78d0d0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d0d0cf",
  null
  
)

export default component.exports